import { throttle } from 'lodash/fp';

import Behavior from 'dashboard/components/GraphCanvasV2/behaviors/behavior';
import CanvasMouseMoveEvent from 'dashboard/components/GraphCanvasV2/events/canvas-mouse-move-event';
import NodeMouseNearEvent from 'dashboard/components/GraphCanvasV2/events/node-mouse-near-event';
import { g6IdToHashableNodeId } from 'dashboard/components/GraphCanvasV2/G6Mapper';
import { Node } from 'dashboard/models/graph';

export default class CanvasMouseTrackerBehavior extends Behavior {
  public get events() {
    return {
      [CanvasMouseMoveEvent.type]: 'handleCanvasMouseMove',
    };
  }

  public reset() {
    return;
  }

  public reactivate() {
    return;
  }

  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  private clientX: number;
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  private clientY: number;

  handleCanvasMouseMove(e: CanvasMouseMoveEvent) {
    const { x: clientX, y: clientY } = e.raw;
    this.clientX = clientX;
    this.clientY = clientY;

    this.throttledResponder();
  }

  throttledResponder = throttle(16, () => {
    const { x: worldX, y: worldY } = this.g6Wrapper.getPointByClient(this.clientX, this.clientY);

    const g6Nodes = this.g6Wrapper.getNodesInBox(
      worldX - 200,
      worldY - 200,
      worldX + 200,
      worldY + 200,
    );
    const nodes: Node[] = [];
    for (const g6Node of g6Nodes) {
      const nodeId = g6IdToHashableNodeId(g6Node.getID());
      if (nodeId) {
        nodes.push(this.graphExplorer.getNodeById(nodeId));
      }
    }

    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    this.eventBus.dispatchEvent(new NodeMouseNearEvent(null, nodes));
  });
}
